import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import ApiService from 'helpers/apiService';
import { getMustChangePassword } from 'helpers/access';

// Блокирующий экран обязательной смены пароля. Показывается, когда у токена
// оператора стоит claim `mcp` (must_change_password) — после того как админ
// сбросил пароль / выдал временный. Оператор не может пользоваться админкой,
// пока не сменит пароль. После успешной смены — logout (флаг снимается в БД,
// новый токен без `mcp` выдаётся при повторном входе).
const ForcePasswordChange: React.FC = () => {
  const mustChange = getMustChangePassword();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!mustChange) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (password.length < 8) {
      setError('Пароль должен быть не короче 8 символов');
      return;
    }
    if (password !== confirm) {
      setError('Пароли не совпадают');
      return;
    }
    setBusy(true);
    try {
      await ApiService.updateOwnPassword(password);
      // Флаг снят в БД; текущий токен всё ещё содержит mcp. Чистим сессию и
      // отправляем на логин — свежий токен придёт уже без mcp.
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      window.location.href = '/authentication/simple/login';
    } catch (err: any) {
      console.error('Force password change failed:', err);
      setError(err?.response?.data?.message || err?.message || 'Не удалось сменить пароль');
      setBusy(false);
    }
  };

  return (
    <Modal show backdrop="static" keyboard={false} centered>
      <Modal.Header>
        <Modal.Title>Смена пароля обязательна</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <p className="small text-muted">
            Для вашей учётной записи установлен временный пароль. Перед продолжением
            работы задайте новый пароль.
          </p>
          {error && <div className="alert alert-danger py-2 small mb-2">{error}</div>}
          <Form.Group className="mb-2">
            <Form.Label className="small">Новый пароль</Form.Label>
            <Form.Control
              size="sm"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoComplete="new-password"
              required
            />
          </Form.Group>
          <Form.Group>
            <Form.Label className="small">Повторите пароль</Form.Label>
            <Form.Control
              size="sm"
              type="password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              autoComplete="new-password"
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" size="sm" type="submit" disabled={busy}>
            {busy ? 'Сохранение...' : 'Сменить пароль'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ForcePasswordChange;
